import { toast } from 'react-toastify';
import React from "react";

const defaultErrorHandling = {
  401: () => {
    toast.error('عدم شناسای هویت')
  },
  403: () => {
    toast.error('عدم امکان دسترسی')
  },
  400: () => {
    toast.error('خطا در داده‌ی ورودی')
  }
};

export const excelFileHandleErros = (response) => {
    if (response.length !== 0){
        if ( typeof response[0] === "string") {
                return response[0]
        }
    }
    if (response["detail"]){
        if ( typeof response["detail"] === "string") {
            return response["detail"]
        }
    }
    if (response["email"]){
            return "فیلد ایمیل باید درست وارد شود"
    }
    if ( typeof response === "string") {
        return response
    }
    if (response["phone_number"]){
            return "فیلد شماره تلفن باید درست وارد شود"
    }
    if (response["first_name"]){
            return "فیلد نام باید درست وارد شود"
    }
    if (response["last_name"]){
            return "فیلد نام خانوادگی باید درست وارد شود"
    }
    if (response["national_code"]){
            return "فیلد کارت ملی باید درست وارد شود"
    }
};

const requestErrorHandling = (error, statusHandler=defaultErrorHandling) => {
    if (error.response) {
        const targetStatusHandler = statusHandler[error.response.status]
        if (targetStatusHandler) {
            targetStatusHandler(error.response.data, error.response)
        }
      } else if (error.request) {
        toast.error('سرور در حال حاضر پاسخگو نیست!')
      } else {
        toast.error('خطا در سیستم!')
        console.log('Error', error.message);
      }
}

export default requestErrorHandling
